module.exports = __webpack_public_path__ + "img/Chad.f921fde5.png";